import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowDownRight } from "lucide-react";

const line = {
  hidden: { y: "110%" },
  visible: (i) => ({
    y: "0%",
    transition: { duration: 0.9, ease: [0.76, 0, 0.24, 1], delay: 0.3 + i * 0.12 },
  }),
};

const Hero = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [0, 220]);
  const scale = useTransform(scrollYProgress, [0, 1], [1, 1.15]);
  const opacity = useTransform(scrollYProgress, [0, 0.8], [1, 0]);

  return (
    <section ref={ref} id="top" className="relative min-h-screen w-full overflow-hidden bg-[#050505]">
      {/* Parallax background */}
      <motion.div style={{ y, scale }} className="absolute inset-0 z-0">
        <img
          src="https://images.unsplash.com/photo-1678366633407-7f49da199a42?crop=entropy&cs=srgb&fm=jpg&q=85"
          alt="abstract tech"
          className="w-full h-full object-cover opacity-50"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-[#050505]/50 to-[#050505]/30" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#050505] via-transparent to-transparent" />
      </motion.div>

      <motion.div style={{ opacity }} className="relative z-10 max-w-[1400px] mx-auto px-6 lg:px-10 min-h-screen flex flex-col justify-end pb-20 pt-32">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2 }}
          className="flex items-center gap-3 mb-8"
        >
          <span className="w-2 h-2 rounded-full bg-accent-wl animate-pulse" />
          <span className="font-body text-xs uppercase tracking-[0.3em] text-white/60">
            Toko Gadget Original & Bergaransi Resmi
          </span>
        </motion.div>

        <h1 data-testid="hero-headline" className="font-display font-black text-white leading-[0.85] tracking-tighter text-[3rem] sm:text-[5rem] lg:text-[8rem]">
          {["Teknologi", "Kelas Dunia,"].map((t, i) => (
            <span key={i} className="block overflow-hidden">
              <motion.span custom={i} variants={line} initial="hidden" animate="visible" className="block">
                {t}
              </motion.span>
            </span>
          ))}
          <span className="block overflow-hidden">
            <motion.span custom={2} variants={line} initial="hidden" animate="visible" className="block font-light italic text-gradient-wl">
              di ujung jarimu.
            </motion.span>
          </span>
        </h1>

        <div className="mt-10 flex flex-col lg:flex-row lg:items-end justify-between gap-8">
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 1, duration: 0.8 }}
            className="font-body text-base sm:text-lg text-white/60 max-w-md"
          >
            Apple, Samsung, GoPro, Microsoft, JBL, Bose, hingga Meta. Kurasi gadget premium terbaik dengan layanan personal Winselindo.
          </motion.p>

          <motion.a
            href="#katalog"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 1.15, duration: 0.8 }}
            data-testid="hero-cta"
            className="group inline-flex items-center gap-3 self-start bg-white text-black rounded-full pl-7 pr-3 py-3 font-body font-semibold hover:bg-gradient-wl hover:text-white transition-colors duration-300"
          >
            Jelajahi Katalog
            <span className="w-9 h-9 rounded-full bg-black text-white flex items-center justify-center group-hover:rotate-45 transition-transform duration-300">
              <ArrowDownRight className="w-4 h-4" />
            </span>
          </motion.a>
        </div>
      </motion.div>
    </section>
  );
};

export default Hero;
